/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Legacy_UpdatingInputs */

const vi_carrier_legacy_updating = /** @type {(inputs: Carrier_Legacy_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải lại danh sách xã, đợi vài giây rồi bấm Tạo vận đơn`)
};

/**

* @param {Carrier_Legacy_UpdatingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_updating = /** @type {((inputs?: Carrier_Legacy_UpdatingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_UpdatingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_updating(inputs)
});